export default __webpack_public_path__ + "static/banner-sobre-10ad18b797fb371d1c633de54a2df6a1.jpg";